var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogomail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9 15C1.3775 15 0.930051 14.8162 0.557651 14.4487C0.185251 14.0812 -0.00063172 13.64 1.6129e-06 13.125V1.875C1.6129e-06 1.35938 0.186202 0.917814 0.558602 0.550314C0.931001 0.182814 1.37813 -0.000623408 1.9 1.59168e-06H17.1C17.6225 1.59168e-06 18.0699 0.183751 18.4423 0.551251C18.8147 0.918751 19.0006 1.36 19 1.875V13.125C19 13.6406 18.8138 14.0822 18.4414 14.4497C18.069 14.8172 17.6219 15.0006 17.1 15H1.9ZM9.5 8.4375L1.9 3.75V13.125H17.1V3.75L9.5 8.4375ZM9.5 6.5625L17.1 1.875H1.9L9.5 6.5625ZM1.9 3.75V1.875V13.125V3.75Z",
    fill: "#009FE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomail);
export default __webpack_public_path__ + "static/media/logomail.250a2a2b6809a33ee82e489cd0c99de4.svg";
export { ForwardRef as ReactComponent };